import { Dayjs } from "dayjs"
import { IWarrantsFilesProcessed } from "@/models/admin/warrantsFilesProcessed/warrantsFilesProcessed.types"
import {
  WarrantsFilesDcaType,
  WarrantsFilesType,
} from "@/models/admin/warrantsFilesAccount/warrantsFilesAccount.types"
import { sentenceCase } from "@/helpers/stringHelpers"

export class WarrantsFilesProcessed implements IWarrantsFilesProcessed {
  constructor(
    public id: number,
    public dcaType: WarrantsFilesDcaType,
    public fileType: WarrantsFilesType,
    public folder: string,
    public fileName: string,
    public jobId: number | null,
    public createdAt: Dayjs,
  ) {}

  get dcaTypeDisplay(): string {
    return sentenceCase(this.dcaType)
  }

  get fileTypeDisplay(): string {
    return sentenceCase(this.fileType)
  }
}
